import ScheduledFee from "@/models/Products/ProductFees/ScheduledFee";

export default class UpdateScheduledFeeRequest extends ScheduledFee {

    public constructor(fee: ScheduledFee) {
        super();
        if (fee) {
            this.id = fee.id;
            this.overridable = fee.overridable;
            this.enabled = fee.enabled;
            this.name = fee.name;
            this.subTransactionType = fee.subTransactionType;
            this.reference = fee.reference;
            this.periodValue = fee.periodValue;
            this.periodType = fee.periodType;
            this.periodOnDayOfWeek = fee.periodOnDayOfWeek;
            this.periodOnDayOfMonth = fee.periodOnDayOfMonth;
            this.periodDayOfMonth = fee.periodDayOfMonth;
            this.periodOnMonth = fee.periodOnMonth;
            this.amount.amount = fee.amount.amount;
            this.amount.currency = fee.amount.currency;
            this.introductoryPeriodValue = fee.introductoryPeriodValue;
            this.introductoryAmount.amount = fee.introductoryAmount.amount;
            this.introductoryAmount.currency = fee.introductoryAmount.currency;
        }
    }
}